// AOFBase/ClientApp/src/app/services/chat.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private chatOpenSubject = new BehaviorSubject<boolean>(false);
  public chatOpen$ = this.chatOpenSubject.asObservable();

  constructor() { }

  toggleChat() {
    this.chatOpenSubject.next(!this.chatOpenSubject.value);
  }

  openChat() {
    this.chatOpenSubject.next(true);
  }

  closeChat() {
    this.chatOpenSubject.next(false);
  }

  setChatState(isOpen: boolean) {
    this.chatOpenSubject.next(isOpen);
  }

  getCurrentState(): boolean {
    return this.chatOpenSubject.value;
  }
}
